import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import LanguageBadgesGrid from "../LanguageBadgesGrid"

const renderItem = (section, id) => {
  return (
    <div
      key={id}
      className="w-full flex flex-col items-center justify-center pt-[25px] pb-[55px] lg:pb-[105px] px-[16px] md:px-px1_l xl:px-4 rounded-b-[100px]"
    >
      {/* Title */}
      <Typography component="h2" variant="h1" className="text-center text-text mb-[16px]">
        {section.title}
      </Typography>
      {/* Description */}
      <Typography
        variant="body1"
        className="w-full max-w-[500px] md:max-w-[870px] text-center mx-auto mb-[40px] md:mb-[60px] xl:mb-[110px]"
      >
        {section.description}
      </Typography>
      {/* Badges Grid */}
      <LanguageBadgesGrid badges={section.badges} />
    </div>
  )
}

const AppDictionarySection = () => {
  return (
    <CMSRender contentType={"AppDictionarySection"} renderItem={renderItem} />
  )
}

export default AppDictionarySection
